import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home/home";
import FourOhFour from "./pages/404/404";
import Navbar from "./components/navbar/navbar";
import Products from "./pages/products/product";
import Cart from "./pages/cart/cart";
import EachProduct from "./pages/eachProduct/eachProduct";
import ResponsiveMenu from "./components/responsive-menu/menu";
import Profile from "./pages/profile/profile";
import ProfileAdd from "./components/address(profile)/profileAdd";
import Orders from "./components/orders/orders";
import UserAccount from "./components/userAccount/userAccount";
import EditUser from "./components/editUserInfo/editUser";
import ProductTableInCart from "./components/productTableInCart/productTableInCart";
import Payment from "./components/payment/payment";
import Register from "./pages/register/register";
import Login from "./pages/login/login";
import { useGlobalContext } from "./context";
import Footer from "./components/footer/footer";
import RequireAuth from '@auth-kit/react-router/RequireAuth'
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import axios from "axios";

function App() {

  axios.defaults.withCredentials = true
  
  const user = useAuthUser()
  const { cart, savedAddress } = useGlobalContext()
  return (
    <BrowserRouter>
      <Navbar data={"auth"} />
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/products" element={<Products />}></Route>
        <Route path="/product/:id" element={<EachProduct />}></Route>
        <Route path="/cart" element={<Cart />}>
          <Route path="/cart" element={<ProductTableInCart route={"cartTable"} />}></Route>
          <Route path={cart.length >= 1 ? "/cart/shipping" : "/cart"} element={
            <RequireAuth fallbackPath="/login">
              <ProfileAdd route={"shipping"} />
            </RequireAuth>
          }></Route>
          <Route path={"/cart/payment"} element={
            <RequireAuth fallbackPath="/login">
              <Payment route={"payment"} />
            </RequireAuth>
          }></Route>
        </Route>
        <Route path="/profile" element={
          <RequireAuth fallbackPath="/login">
            <Profile />
          </RequireAuth>
        }>
          <Route path="/profile" element={<UserAccount />}></Route>
          <Route path="/profile/address" element={<ProfileAdd />}></Route>
          <Route path="/profile/orders" element={<Orders />}></Route>
          <Route path="/profile/editUserInfo" element={<EditUser />}></Route>
          <Route path="*" element={<FourOhFour />}></Route>
        </Route>
        {
          !user &&
          <>
            <Route path="/register" element={<Register />}></Route>
            <Route path="/login" element={<Login />}></Route>
          </>
        }
        <Route path="*" element={<FourOhFour />}></Route>
      </Routes>
      <ResponsiveMenu data={"auth"} />
      <Footer data={"auth"} />
    </BrowserRouter>
  );
}

export default App;
